// router.js 
// https://router.vuejs.org/zh/

import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Index from '../pages/index.vue'
import Login from '../pages/mp/login.vue'
import MpIndex from '../pages/mp/index.vue'
import MpFeedback from '../pages/mp/feedback.vue'
import MpWords from '../pages/mp/words.vue'
import MpActivity from '../pages/mp/activity.vue'
import MpActivityDetail from '../pages/mp/activityDetail.vue'
import MpActivityGather from '../pages/mp/activityGather.vue'
import Scanlogin from '../pages/scanlogin.vue'
import MpStaff from '../pages/mp/staff.vue'
import MpCoffee from '../pages/mp/coffee.vue'
import MpCoffeeInput from '../pages/mp/coffeeInput.vue'


export default new VueRouter({
    mode: "history",  //vue-router路由模式的默认方式
    routes: [
        // { path: '/user/:id', component: User }
        { name: "Home", path: "/", component: Index },
        { name: "Login", path: "/login", component: Login },
        { name: "ScanLogin", path: "/scanlogin", component: Scanlogin },
        { name: "MpIndex", path: "/mp", component: MpIndex },
        { name: "MpFeedback", path: "/mp/feedback", component: MpFeedback },
        { name: "MpActivity", path: "/mp/activity", component: MpActivity },
        { name: "MpActivity", path: "/mp/activity/detail/:uuid", component: MpActivityDetail },
        { name: "MpActivityGather", path: "/mp/activity/gather/:uuid", component: MpActivityGather },
        { name: "MpWords", path: "/mp/words", component: MpWords },
        { name: "MpStaff", path: "/mp/staff", component: MpStaff },
        { name: "MpCoffee", path: "/mp/coffee", component: MpCoffee },
        { name: "MpCoffeeInput", path: "/mp/coffeeInput", component: MpCoffeeInput },
    ]
})